import { CALL_API, Schemas } from '../store/api';
import qs from 'query-string';

export const ACTIVITY_REQUEST = 'ACTIVITY_REQUEST';
export const ACTIVITY_REQUEST_INITIAL = 'ACTIVITY_REQUEST_INITIAL';
export const ACTIVITY_SUCCESS = 'ACTIVITY_SUCCESS';
export const ACTIVITY_FAILURE = 'ACTIVITY_FAILURE';
export const ADD_COMMENT_REQUEST = 'ADD_COMMENT_REQUEST';
export const ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS';
export const ADD_COMMENT_FAILURE = 'ADD_COMMENT_FAILURE';
export const UPDATE_COMMENT_REQUEST = 'UPDATE_COMMENT_REQUEST';
export const UPDATE_COMMENT_SUCCESS = 'UPDATE_COMMENT_SUCCESS';
export const UPDATE_COMMENT_FAILURE = 'UPDATE_COMMENT_FAILURE';
export const DELETE_COMMENT_REQUEST = 'DELETE_COMMENT_REQUEST';
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS';
export const DELETE_COMMENT_FAILURE = 'DELETE_COMMENT_FAILURE';
export const SINGLE_ACTIVITY_REQUEST = 'SINGLE_ACTIVITY_REQUEST';
export const SINGLE_ACTIVITY_SUCCESS = 'SINGLE_ACTIVITY_SUCCESS';
export const SINGLE_ACTIVITY_FAILURE = 'SINGLE_ACTIVITY_FAILURE';


export const fetchActivity = (from, contactId, activityType) => (dispatch, getState) => {
    var params = {
        limit: '6',
        contactId: contactId ? contactId : undefined,
        from: from ? from : undefined,
        activityType: activityType && activityType !== 'AllUpdates' ? activityType : undefined
    }
    return dispatch({
        [CALL_API]: {
            types: [ACTIVITY_REQUEST, ACTIVITY_SUCCESS, ACTIVITY_FAILURE],
            method: 'GET',
            endpoint: `activity?${qs.stringify(params)}`,
            schema: Schemas.ACTIVITY_ARRAY
        },
        key: 'feed',
        isNewSearch: !from // from is set when it's not contactId or activityType change and they are scrolling the feed
    })
};

export const addComment = (body) => ({
    [CALL_API]: {
        types: [ADD_COMMENT_REQUEST, ADD_COMMENT_SUCCESS, ADD_COMMENT_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'comments/save'
    },
    key: 'feed'
});

export const updateComment = (body) => ({
    [CALL_API]: {
        types: [UPDATE_COMMENT_REQUEST, UPDATE_COMMENT_SUCCESS, UPDATE_COMMENT_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'comments/update'
    },
    key: 'feed'
});

export const deleteComment = (id) => ({
    [CALL_API]: {
        types: [DELETE_COMMENT_REQUEST, DELETE_COMMENT_SUCCESS, DELETE_COMMENT_FAILURE],
        method: 'POST',
        endpoint: 'comments/delete?Id=' + id
    },
    key: 'feed'
});

export const fetchSingleActivity = (id) => ({
    [CALL_API]: {
        types: [SINGLE_ACTIVITY_REQUEST, SINGLE_ACTIVITY_SUCCESS, SINGLE_ACTIVITY_FAILURE],
        method: 'GET',
        endpoint: 'activity/' + id,
        schema: Schemas.ACTIVITY_INDIVIDUAL
    },
    key: 'single'
});

